import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IContactGroup } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ContactGroupService extends BaseService<IContactGroup> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'contactGroup');
  }
}

export { IContactGroup } from '../shared/api';
